<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_table_of_contents_1">To all those who demanded Ty get his happily ever after. It’s because of you that this series was written. To Sam, who demanded I write Tek &amp; Jamie’s story. And to Erika and Jason, the two best editors in the world. Thank you for keeping all this straight and for making me shine. I love you both!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?3ad51e73